import styles from './styles.scss';

export const HighlightedSpan = ({ children, offsetKey }) => (
  <span className={styles.highlightedSpan} data-offset-key={offsetKey}>
    {children}
  </span>
);
